/* eslint-disable no-console */

export default class Logger {
  static log(...messages) {
    this.fire('log', ...messages);
  }

  static debug(...messages) {
    this.fire('log', ...messages);
  }

  static warn(...messages) {
    this.fire('warn', ...messages);
  }

  static error(...messages) {
    this.fire('error', ...messages);
  }

  static fire(handler, ...messages) {
    const prependedMessage = '[GWI Brick]';

    if (!(/MSIE 10/i.test(navigator.userAgent))
        && !(/MSIE 9/i.test(navigator.userAgent))) {
      console[handler](prependedMessage, ...messages);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/helpers/logger.js